import {SocialInsurance} from '../../interfaces/core/social-Insurance';


export class SocialInsuranceFactory {

  /**
   *
   * @param socialInsurance
   */
  public static fromObject(socialInsurance: any): SocialInsurance {
    return new class implements SocialInsurance {
      id: number = socialInsurance.id;
      shortName: string = socialInsurance.short_name;
      longName: string = socialInsurance.long_name;
    };
  }
}
